module.exports = __webpack_public_path__ + "static/media/swissroc.75e30354.png";